import React, { memo, useEffect } from "react";

import { CustomModal } from "../../../../../components/CustomModal";
import type { IEditUser } from "../../MembersTable/MembersTable";
import { RemoveMemberFooter } from "./RemoveMemberFooter";

interface IProps {
  member: IEditUser | null;
  closeModal: () => void;
  onUserDelete: (userId: string) => void;
  isProcessing: boolean;
}

const RemoveMemberModal: React.FC<IProps> = memo(
  ({ member, closeModal, onUserDelete, isProcessing }) => {
    const { firstName, lastName, email, id } = member || {};

    const cancelDelete = () => {
      closeModal();
    };
    const deleteMember = async () => {
      if (id) {
        try {
          await onUserDelete(id);
        } catch (e) {
          console.error(e);
        }
      }
    };

    return (
      <CustomModal
        title="Delete member"
        show={true}
        handleClose={closeModal}
        footer={
          <RemoveMemberFooter
            cancelDelete={cancelDelete}
            deleteMember={deleteMember}
            isProcessing={isProcessing}
          />
        }
      >
        <div>
          <p>
            <b>
              {firstName} {lastName} ({email})
            </b>{" "}
            will be deleted permanently and this action cannot be undone.{" "}
          </p>

          <p>Are you sure you want to delete the member item?</p>
        </div>
      </CustomModal>
    );
  },
);

export { RemoveMemberModal };
